import { inputs } from '@ecosystem/newron-design-system';
import React, { useCallback } from 'react';

import { MAX_DESCRIPTION_LENGTH } from '../../constants';

const { TextArea } = inputs;

export interface AddInsightDescriptionProps {
  description?: string;
  setDescription: (description: string) => void;
}

export const AddInsightDescription: React.FC<AddInsightDescriptionProps> = ({ description, setDescription }) => {
  const handleSetDescription = useCallback(
    (description: string) => {
      setDescription(description);
    },
    [setDescription]
  );

  return (
    <TextArea
      onChange={handleSetDescription}
      name="insightDescription"
      label="Insight description (optional)"
      value={description}
      placeholder="Add a description to provide additional context for this insight"
      rows={2}
      maxLength={MAX_DESCRIPTION_LENGTH}
      testId="insightDescription"
    />
  );
};
